// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ufs-dropdown[data-v-d7d5e0c8]{height:60px}.dropdown-items[data-v-d7d5e0c8]{top:70px}.icon-chevron[data-v-d7d5e0c8]{right:10px;top:64%;transition:transform .2s ease-in-out}.icon-chevron.flipped[data-v-d7d5e0c8]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
